export const faqContent = {
  categories: [
    {
      id: "general",
      title: "General",
      questions: [
        {
          id: "what-is-devolysis",
          question: "What services do you offer?",
          answer: "Web development, mobile apps, and AI automation solutions.",
        },
        {
          id: "technologies",
          question: "What technologies do you use?",
          answer:
            "Websites: Vue, React. Mobile Apps: Flutter. Backend: Django, Springboot, Firebase. Database Management System: As client requirement. DevOps: As client requirement.",
        },
        {
          id: "remote",
          question: "Do you work with remote clients?",
          answer: "Yes, we work with clients worldwide.",
        },
      ],
    },
    {
      id: "project",
      title: "Project & Pricing",
      questions: [
        {
          id: "timeline",
          question: "How long does a project take?",
          answer:
            "Depends on the requirements. It can take from 1 month to 6 months.",
        },
        {
          id: "cost",
          question: "What does a project cost?",
          answer:
            "Depends on the size and complexity of the project. It can range from basic $100 to $2,000 project to big $5,000 to $10,000 project.",
        },
        {
          id: "payment",
          question: "What are the payment terms?",
          answer: "20% deposit, then milestone payments until completion.",
        },
        {
          id: "ownership",
          question: "Who owns the code?",
          answer: "You own everything upon full payment.",
        },
      ],
    },
    {
      id: "getting-started",
      title: "Getting Started",
      questions: [
        {
          id: "how-to-start",
          question: "How do I get started?",
          answer:
            "Book a free 30-minute consultation through our contact page.",
        },
        {
          id: "contact",
          question: "How can I reach you?",
          answer: "Email contact@devolysis.com or call +1 (307) 487-8301.",
        },
      ],
    },
  ],
};
